<template>
  <div class="how-work" id="how-work">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2 class="container__title how-work__title">Как это работает</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <ul class="work-switch">
                    <li
                        class="work-switch__item"
                        v-for="tab in tabs"
                        :key="tab"
                        :class="{ active: tab === selectedTab }"
                        @click="selectTab(tab)"
                    >
                        {{ tab }}
                    </li>
                </ul>
                <div class="work-switch__body d-flex" v-if="isLoading">
                    <div class="LoaderBalls">
                        <div class="LoaderBalls__item"></div>
                        <div class="LoaderBalls__item"></div>
                        <div class="LoaderBalls__item"></div>
                    </div>
                </div>
                <div class="work-switch__body" style="display: none"
                     :style="{display: (!isLoading && selectedTab === 'Для волонтера') ? 'block' : 'none'}">
                    <volunteer-block/>
                </div>
                <div class="work-switch__body" style="display: none"
                     :style="{display: (!isLoading && selectedTab === 'Для жертвователя') ? 'block' : 'none'}">
                    <donor-block/>
                </div>
                <div class="work-switch__body" style="display: none"
                     :style="{display: (!isLoading && selectedTab === 'Для бизнеса') ? 'block' : 'none'}">
                    <business-block/>
                </div>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import VolunteerBlock from './chunk/VolunteerBlock'
import DonorBlock from './chunk/DonorBlock'
import BusinessBlock from './chunk/BusinessBlock'
import Loader from './Loader'

export default {
  name: 'HowWork',
  data() {
    return {
      tabs: ['Для волонтера', 'Для жертвователя', 'Для бизнеса'],
      selectedTab: 'Для волонтера',
      isLoading: false,
      ComponentFade: false,

    }
  },
  components: { VolunteerBlock, DonorBlock, Loader, BusinessBlock },
  computed: {
    swithcedWork() {
            if (this.selectedTab === this.tabs[0]) {
                return 'VolunteerBlock'
            } else if (this.selectedTab === this.tabs[1]) {
                return 'DonorBlock'
            }
            return 'VolunteerBlock'
    }
  },

    watch:{
    },
  methods: {
    selectTab(t) {
        this.selectedTab = t

        this.isLoading = true
        setTimeout(()=>{
            this.isLoading = false
        },1000)

    }
  }
}
</script>

<style lang="scss">


.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        // .LoaderBalls__wrapper__item
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6,.05,.15,.95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}

    .work-switch__body{
        align-items: center;
    }

    .how-work {
        position: relative;
        padding-top: 35px;
        font-family: Comfortaa, sans-serif;
        margin-bottom: -3px;

        &::after{
            position: absolute;
            content: '';
            display: block;
            left: 0;
            right: 0;
            bottom: 0;
            height: 70px;
            background: #eaf1fc;
        }

        &__title {
            margin-bottom: 50px;
        }
        &__container {
            padding: 0 !important;
        }

        .work-switch {
            max-width: 400px;
            margin: 0 auto;
            background: #eaf1fc;
            border-radius: 45px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 32px;
            &__item {
                font-weight: bold;
                font-size: 12px;
                line-height: 20px;
                color: #2e76e4;
                padding: 10px 15px;
                border-radius: 45px;
                transition: color 0.4s ease, background 0.3s ease;
                cursor: pointer;
                flex-grow: 1;
                &.active {
                    background: #2e76e4;
                    color: #fff;
                }

                //&+.work-switch__item{
                //    margin-left: -15px;
                //}
            }
            &__body {
                min-height: 500px;
                position: relative;
            }
        }
    }

    @media screen and (max-width: 992px){
        .how-work__title{
            text-align: center;
            margin-bottom: 30px;
        }
        .volunteer__legs .svg-icon{
            min-height: auto;
        }
    }

@media screen and (max-width: 500px){
    .how-work .work-switch{
        flex-wrap: wrap;
        justify-content: center;
        background: transparent;
    }

    .how-work .work-switch__item{
        width: calc(50% - 10px);
        text-align: center;
        background: #eaf1fc;
        flex-grow: 0;
        margin: 5px;
        padding: 10px 8px;
    }
}


</style>
